import ErrorResponse from '../models/ErrorResponse';

export default class BaseApi {
    public baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    getJwt = (): string => {
        return localStorage.getItem('jwt') || sessionStorage.getItem('jwt');
    };

    public getRequest(url: string, jwt: string | undefined = undefined) {
        return fetch(url, this.getHeader(jwt)).then(this.handleApiCall).catch(this.handleApiError);
    }

    public postRequest(url: string, body: object, jwt: string | undefined = undefined) {
        return fetch(url, this.postHeader(body, jwt)).then(this.handleApiCall).catch(this.handleApiError);
    }

    public putRequest(url: string, body: object, jwt: string | undefined = undefined) {
        return fetch(url, this.putHeader(body, jwt)).then(this.handleApiCall).catch(this.handleApiError);
    }

    public deleteRequest(url: string, body: object, jwt: string | undefined = undefined) {
        return fetch(url, this.deleteHeader(body, jwt)).then(this.handleApiCall).catch(this.handleApiError);
    }

    public postRequestFileUpload(url: string, body: FormData, jwt: string | undefined = undefined) {
        return fetch(url, this.postFileUploadHeader(body, jwt)).then(this.handleApiCall).catch(this.handleApiError);
    }

    // TODO: refactor and make private
    public getHeader(jwt: string | undefined) {
        const header: RequestInit = {
            headers: this.createHeader(),
            method: 'GET',
            mode: 'cors',
        };
        return header;
    }

    // TODO: refactor and make private
    public postHeader(body: object, jwt: string | undefined = undefined) {
        const header: RequestInit = {
            body: JSON.stringify(body),
            headers: this.createHeader(),
            method: 'POST',
            mode: 'cors',
        };
        return header;
    }

    public putHeader(body: object, jwt: string | undefined = undefined) {
        const header: RequestInit = {
            body: JSON.stringify(body),
            headers: this.createHeader(),
            method: 'PUT',
            mode: 'cors',
        };
        return header;
    }

    public deleteHeader(body: object, jwt: string | undefined = undefined) {
        const header: RequestInit = {
            body: JSON.stringify(body),
            headers: this.createHeader(),
            method: 'DELETE',
            mode: 'cors',
        };
        return header;
    }

    public postFileUploadHeader(body: FormData, jwt: string | undefined = undefined) {
        const options = {
            method: 'POST',
            body: body,
            headers: { Authorization: `Bearer ${jwt}` },
        };
        return options;
    }

    private handleApiCall(value: Response) {
        return new Promise<object>((resolve) => {
            if (value.ok) {
                value
                    .json()
                    .then((body) => resolve(body))
                    .catch(() => resolve());
            } else {
                resolve(value.json().then((response: ErrorResponse) => new ErrorResponse(response.messageCode, response.message)));
            }
        });
    }

    private handleApiError() {
        return new ErrorResponse('42', 'Unable to connect to the server');
    }

    private createHeader() {
        let headers = {};

        const jwt = this.getJwt();

        if (jwt) {
            headers = {
                'content-type': 'application/json',
                Authorization: `Bearer ${jwt}`,
            };
        } else {
            headers = { 'content-type': 'application/json' };
        }

        return headers;
    }
}



// WEBPACK FOOTER //
// ./src/api/BaseApi.ts